import { lazy, Suspense } from 'react';

type FileIconProps = {
  filename: string;
};

const FileIconImpl = lazy(() => import('./file-icon-impl').then((m) => ({ default: m.FileIcon })));

function FileIconFallback() {
  return <div className="flex size-8 min-h-8 min-w-8 items-center justify-center rounded-md bg-gray-100" />;
}

export function FileIcon(props: FileIconProps) {
  return (
    <Suspense fallback={<FileIconFallback />}>
      <FileIconImpl {...props} />
    </Suspense>
  );
}
